<mat-form-field appearance="outline" class="mat-input-custom" [ngClass]="visuallyDisabledFields['engine_number'] ? 'visually-disabled' : ''"
>
  <mat-label>Engine Number</mat-label>
  <input
    matInput
    formControlName="engine_number"
    class="text-uppercase"
    id-automation="engine_number"
    minlength="6"
    maxlength="25"
    appNoMaskedValue
    (input)="onFieldChange()"
    [readonly]="visuallyDisabledFields['engine_number']"
  />
  <mat-error *ngIf="engineForm.controls['engine_number']?.hasError('required')">
    This is a required field.
  </mat-error>
  <mat-error
    *ngIf="engineForm.controls['engine_number']?.hasError('minlength')"
  >
    Cannot be less than 6 Characters
  </mat-error>
  <mat-error *ngIf="engineForm.get('engine_number')?.hasError('invalidEngineNumber')">
    Please enter a valid engine number
  </mat-error>
</mat-form-field>
